import { Col, Layout, Row, theme } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from '../../../general/logo';
import styles from './styles.module.scss';

const { Sider } = Layout;

const AdminSider: React.FC = (): JSX.Element => {
  const navigate = useNavigate();
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  return (
    <>
      <Sider
        style={{
          background: '#303843',
          position: 'fixed',
          top: 0,
          zIndex: 110,
          height: '100vh',
        }}
        width="122px"
      >
        <div style={{ marginTop: '30px' }}>
          <Logo {...{ size: 'small' }} />
        </div>
        <Row justify="center" style={{ marginTop: '50px' }}>
          <Col>
            <div
              onClick={() => navigate('/admin')}
              style={{ all: 'unset', cursor: 'pointer' }}
            >
              <Row justify="center">
                <img src="/dashboard.png" />
              </Row>
              <Row justify="center">
                <p className={styles.text}>Home</p>
              </Row>
            </div>
            <div
              onClick={() => navigate('/admin/employee')}
              style={{ all: 'unset', cursor: 'pointer' }}
            >
              <Row justify="center">
                <img src="/badge.png" />
              </Row>
              <Row justify="center">
                <p className={styles.text}>Employee</p>
              </Row>
            </div>
            <div
              onClick={() => navigate('/admin/skills')}
              style={{ all: 'unset', cursor: 'pointer' }}
            >
              <Row justify="center">
                <img src="/psychology.png" />
              </Row>
              <Row justify="center">
                <p className={styles.text}>Skills</p>
              </Row>
            </div>
            <div
              onClick={() => navigate('/admin/reports')}
              style={{ all: 'unset', cursor: 'pointer' }}
            >
              <Row justify="center">
                <img src="/reports.png" />
              </Row>
              <Row justify="center">
                <p className={styles.text}>Reports</p>
              </Row>
            </div>
          </Col>
        </Row>
      </Sider>
    </>
  );
};

export default AdminSider;
